import React, {Fragment, useContext, useEffect, useState} from "react";
import MetaTagsManipulator from "../../utils/MetaTagsManipulator";
import {useHistory, useParams} from "react-router";
import {goVehisService} from "../../utils/axios";
import HeadSection from "./HeadSection";
import {Spinner} from "@blueprintjs/core";
import VehicleImage from "./VehicleImage";
import OfferVariants from "./OfferVariants";
import VehicleInfo from "./VehicleInfo";
import UrlDecorator from "../../utils/UrlDecorator";
import Reservation from "../Reservation/Reservation";
import {CustomerTypeContext} from "../../context/customer-type-context";
import ConvertUtils from "../../utils/ConvertUtils";
import PrintSellerContact from "../../components/PrintSellerContact/PrintSellerContact";
import PrintLogo from "../../components/PrintLogo/PrintLogo";
import RecommendedOffers from "./RecommendedOffers";
import ProcessSteps from "../../components/ProcessSteps/ProcessSteps";
import InstallmentCalculatorStrategy from "./InstallmentCalculator/InstallmentCalculatorStrategy";
import Attachments from "./Attachments";
import CreditReservation from "../CreditReservation/CreditReservation";
import CustomerTypeSwitch from "../../components/CustomerTypeSwitch/CustomerTypeSwitch";
import ExpertHelp from "../HomePage/ExpertHelp";
import HomeNewsletter from "../HomePage/HomeNewsletter";

function OfferPage() {

    UrlDecorator.addSellerCode();

    const [offer, setOffer] = useState(null);
    const [showOrder, setShowOrder] = useState(false);
    const [showOderForCredit, setShowOrderForCredit] = useState(false);
    const [calculationOffer, setCalculationOffer] = useState(null);
    const setCompanyOnly = useContext(CustomerTypeContext)[4];
    const searchParams = useParams();

    const history = useHistory();

    useEffect(() => {
        goVehisService(`/vehicles/offers/${searchParams.id}`).then(response => {
            let vehicleOffer = response.data;
            if (vehicleOffer !== undefined) {
                setOffer({...vehicleOffer, isNew: vehicleOffer.condition === 'NEW'});

                let vehicleName = vehicleOffer.brandName + " " + vehicleOffer.versionName;

                let isPromotionalCompanyOnly = vehicleOffer.promotionalOffer != null
                    && vehicleOffer.promotionalOffer.availableForConsumer !== true;
                setCompanyOnly(vehicleOffer.customerType.length < 2 || isPromotionalCompanyOnly);

                MetaTagsManipulator.setTitle(vehicleName);
                MetaTagsManipulator.setDescription(vehicleName);
            }
        }).catch(error => {
            goVehisService(`/vehicles/variants?brand=${searchParams.brand}&version=${encodeURIComponent(searchParams.version)}`).then(response => {
                let vehicleOffer = response.data;
                if (vehicleOffer) {
                    history.replace(
                        ConvertUtils.stringToUrl("/" + vehicleOffer.brandName + "/" + vehicleOffer.versionName.trim() + "/" + vehicleOffer.id));
                }else{
                    goVehisService(`/vehicles/model?version=${searchParams.version}&sortingType=ADDED_DATE_ASC&start=0&limit=10`).then(response => {
                        let modelVersions = response.data;
                        if(modelVersions.length > 0){
                            const representativeModel = modelVersions[0];
                            history.replace(`/lista-ofert?brands=${representativeModel.brandName}&models=${representativeModel.modelName}`);
                        }else{
                            goVehisService(`/vehicles/segment?version=${searchParams.version}&sortingType=ADDED_DATE_ASC&start=0&limit=10`).then(response => {
                                let segmentName = response.data;

                                if(segmentName !== "undefined_segment"){
                                    history.replace(`/lista-ofert?segments=${segmentName}`);
                                }else{
                                    history.replace(
                                        ConvertUtils.stringToUrl(`/lista-ofert`));
                                }
                            })
                        }
                    })
                }
            })
        });

    }, [searchParams]);

    useEffect(() => {
        UrlDecorator.addUtmParameters(sessionStorage.getItem("UTM_SOURCE"),
                                      sessionStorage.getItem("UTM_MEDIUM"),
                                      sessionStorage.getItem("UTM_CAMPAIGN"))
    }, [window.location.href])

    const scrollToCalculatorHandler = () => {
        const calculator = document.getElementById('single-right');
        if (calculator) {
            window.scrollTo({behavior: 'smooth', top: calculator.getBoundingClientRect().top + window.scrollY - 100});
        }
    }

    const showOrderClick = (showOrder, calculationOffer) => {
        setShowOrder(showOrder);
        setCalculationOffer(calculationOffer);
        window.scrollTo({behavior: 'smooth', top: 150});
    }

    const showOrderClickForCredit = (showOrder, calculationOffer) => {
        setShowOrderForCredit(showOrder);
        setCalculationOffer(calculationOffer);
        window.scrollTo({behavior: 'smooth', top: 150});
    }

    if(showOrder){
        return (<Reservation offer={calculationOffer} onShowOffer={() => {
            setShowOrder(false)
        }} />);
    }

    if(showOderForCredit) {
        return (<CreditReservation offer={calculationOffer} onShowOffer={() => {
            setShowOrderForCredit(false);
            window.location.reload(true);
        }} />);
    }

    if (offer) {
        return (
                <Fragment>
                    <HeadSection offer={offer}/>
                    <PrintLogo />
                    <div id="content">
                        <div className="container side-padding flex">

                            <div id="single-left">
                                <VehicleImage offer={offer}/>
                                <OfferVariants offerId={offer.id}/>
                                <VehicleInfo offer={offer} />
                                <Attachments attachments={offer.attachments} />
                            </div>
                            <div id="single-right">
                                <div className="single-toggle">
                                    <CustomerTypeSwitch/>
                                </div>
                                <InstallmentCalculatorStrategy
                                    offer={offer}
                                    initialCalculation={ calculationOffer ? calculationOffer.calculation : null}
                                    onShowOrderClick={showOrderClick}
                                    onShowOrderClickForCredit={showOrderClickForCredit}/>
                            </div>

                        </div>
                        <ProcessSteps
                            heading="Jak to działa?"
                            subheading="Prosty proces w 5 krokach — od wyboru auta po odbiór kluczyków."
                            ctaLabel="Złóż wniosek"
                            onCtaClick={scrollToCalculatorHandler}
                        />
                        <ExpertHelp/>
                        <RecommendedOffers offer={offer} />
                        <HomeNewsletter/>
                    </div>


                    <PrintSellerContact/>
                </Fragment>
        );
    }

    return <Spinner/>;
}

export default OfferPage;